<script>
export default {
  name: 'Pagination',
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(1, this.totalPages - this.maxVisibleButtons + 1);
      }

      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
  },
};
</script>

<template>
  <nav v-show="totalPages > 1" class="c-pagination">
    <button
      @click="onClickPreviousPage"
      v-show="!isInFirstPage"
      class="c-pagination__link"
      type="button"
      aria-label="Previous Page"
      title="Previous Page"
    >
      <span role="presentation">«</span>
    </button>

    <button
      v-for="page in pages"
      v-bind:key="page.name"
      @click="onClickPage(page.name)"
      :disabled="page.isDisabled"
      :title="'Page '+page.name"
      :class="isPageActive(page.name) ? 'c-pagination__current' : 'c-pagination__link'"
      type="button"
    >{{ page.name }}</button>

    <button
      class="c-pagination__link"
      type="button"
      @click="onClickNextPage"
      v-show="!isInLastPage"
      aria-label="Next Page"
      title="Next Page"
    >
      <span role="presentation">»</span>
    </button>
  </nav>
</template>
